// extracted by mini-css-extract-plugin
module.exports = {"headerAction":"headerAction--1vHTq"};